import { useState } from "react"
import axiosInstance from '../../../axios.config';
import { toast } from 'react-toastify';

export const useEditCourse = (
    lngsltd,
    fetchCourseSteps
) => {
    const [showedit, setShowEdit] = useState(false);
    const [editID, setEditID] = useState('')
    const [editCourseID, setEditCourseID] = useState('')
    const [editStepNo, setEditStepNo] = useState('')
    const [editStepTitle, setEditStepTitle] = useState('')
    const [editStepContent, setEditStepContent] = useState('')
    const [editContentType, setEditContentType] = useState('')
    const [editDescription, setEditDescription] = useState('')

    const handleShowEdit = () => setShowEdit(true);
    const handleCloseEdit = () => setShowEdit(false);

    const handleEdit = async (id) => {
        handleShowEdit();
        axiosInstance
            .get(`/CourseStep/${id}`)
            .then((result) => {
                setEditCourseID(result.data.courseID);
                setEditStepNo(result.data.stepNo);
                setEditStepTitle(result.data.stepTitle);
                setEditStepContent(result.data.stepContent);
                setEditContentType(result.data.contentType);
                setEditDescription(result.data.description);
                setEditID(id);
            })
            .catch((error) => {
                // console.log(error)
            });
    };

    const handleUpdate = (step) => {
        const url = `/CourseStep/${editID}`;
        const data = {
            id: editID,
            courseID: editCourseID,
            stepNo: editStepNo,
            stepTitle: editStepTitle,
            stepContent: editStepContent,
            contentType: editContentType,
            description: editDescription,
        };
        axiosInstance
            .put(url, data)
            .then((result) => {
                handleCloseEdit();
                fetchCourseSteps();
                toast.success(lngsltd["Step Title has been updated"]);
            })
            .catch((error) => {
                toast.error(error);
            });
    };

    return {
        showedit,
        editStepTitle,
        handleCloseEdit,
        setEditStepTitle,
        handleEdit,
        handleUpdate,
    };
}

